// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()

////// hyper.js ////
require("bootstrap")
require("js-cookie")
require("sortablejs")
require('blueimp-load-image/js/load-image');
window.jQuery = jQuery;
require("../hyper/vendor/metisMenu.js")
require("../hyper/vendor/jquery.toast.min.js")
require("../hyper/vendor/select2.min")
require("../hyper/vendor/bootstrap-timepicker.min.js")
require("../hyper/vendor/bootstrap-datepicker.min.js")
require("../hyper/vendor/bootstrap-datepicker.ja.js")
require("../hyper/vendor/typeahead.bundle.min")
require("../hyper/layout")
require("../hyper/hyper")

require("../src/common")
require("../src/images")
require("../src/dashboard")

global.jQuery, global.$ = require("jquery");

